import { render } from "./SubcategoryElement.vue?vue&type=template&id=65553d0a"
import script from "./SubcategoryElement.vue?vue&type=script&lang=js"
export * from "./SubcategoryElement.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__